import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router";
import { adminApi, session } from "../../lib/api";

export function AdminVerify() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token");
  const [status, setStatus] = useState<"verifying" | "ok" | "bad">(
    "verifying",
  );

  useEffect(() => {
    if (!token) return;
    adminApi
      .verifyMagicLink(token)
      .then((resp) => {
        session.set(resp.access_token);
        setStatus("ok");
        navigate("/admin/dashboard", { replace: true });
      })
      .catch(() => setStatus("bad"));
  }, [token, navigate]);

  // A missing token is knowable during render, so derive it rather than
  // writing state from the effect. Same end state, minus the brief
  // "Verifying..." flash that the old setState-in-effect produced.
  const view = token ? status : "bad";

  return (
    <section className="mx-auto max-w-md px-4 py-10">
      {view === "verifying" && <p>Verifying sign-in link&hellip;</p>}
      {view === "ok" && <p>Signed in. Redirecting&hellip;</p>}
      {view === "bad" && (
        <>
          <h1 className="text-xl font-semibold">Link invalid or expired</h1>
          <p className="mt-2 text-slate-600">
            Request a new sign-in link from the{" "}
            <a className="text-blue-600 underline" href="/admin/login">
              admin login page
            </a>
            .
          </p>
        </>
      )}
    </section>
  );
}
